/**
 * @fileoverview Application entry point and root rendering
 *
 * This file serves as the main entry point for the React application,
 * handling the initial DOM rendering and React setup.
 *
 * Key responsibilities:
 * - Import global styles (index.css with custom theme)
 * - Create React root using React 18's new createRoot API
 * - Wrap app in StrictMode for development checks
 * - Mount the App component to the DOM
 *
 * The setup follows React 18 best practices:
 * - Uses createRoot instead of legacy ReactDOM.render
 * - Enables StrictMode for enhanced development experience
 * - Includes TypeScript strict null checks (!)
 */

import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './app.tsx';

/**
 * Initialize and render the React application
 *
 * Creates the React root and renders the App component within StrictMode.
 * StrictMode helps identify potential issues in the application during development.
 *
 * The root element is expected to exist in the HTML template (index.html).
 * TypeScript's non-null assertion (!) is used since we know the element exists.
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
